import { IconButton } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

import { useDisclosure } from '@hooks/useDisclosure';
import { useNatureOfBusinessForm } from '@Router/NatureOfBusiness/Containers/NatureOfBusinessFormProvider';
import { INCOME_SUBGROUP_CATEGORY } from 'src/Enum/IncomeStructure';
import OtherIncomeModal from '../OtherIncomeModal/OtherIncomeModal';
import { IIncomeStructureFormValues } from '@Router/NatureOfBusiness/Containers/NatureOfBusinessFormProvider/types';

type OtherIncomeEditButtonProps = {
  keyItem: string;
  subgroup: INCOME_SUBGROUP_CATEGORY;
};

const OtherIncomeEditButton = ({
  keyItem,
  subgroup,
}: OtherIncomeEditButtonProps) => {
  const [opened, { open, close }] = useDisclosure();
  const { getValues, watch } = useNatureOfBusinessForm();

  const completedSection = watch(
    'incomeStructure.completedSection'
  ) as IIncomeStructureFormValues['completedSection'];
  const { isCompletedTh = false, isCompletedEn = false } =
    completedSection ?? {};

  const otherIncomeItems = getValues(
    'incomeStructure.otherIncomeItems'
  ) as IIncomeStructureFormValues['otherIncomeItems'];
  const editData = otherIncomeItems[keyItem].incomeCategory;

  return (
    <>
      <IconButton
        color="inherit"
        size="small"
        sx={{ padding: 0 }}
        onClick={open}
        disabled={isCompletedTh && isCompletedEn}
      >
        <EditOutlinedIcon style={{ fontSize: '14px' }} />
      </IconButton>
      {opened && (
        <OtherIncomeModal
          subgroup={subgroup}
          mode="edit"
          open={opened}
          close={close}
          keyItem={keyItem}
          editData={editData}
        />
      )}
    </>
  );
};

export default OtherIncomeEditButton;
